export type LeanCustomsCreateStepId =
  | "create_order"
  | "sync_costs"
  | "link_booking"
  | "packing_slip"
  | "upload_documents"
  | "upload_attachments"
  | "complete";

export type LeanCustomsCreateStepStatus =
  | "pending"
  | "active"
  | "done"
  | "error"
  | "skipped";

export type LeanCustomsCreateStep = {
  id: LeanCustomsCreateStepId;
  label: string;
  status: LeanCustomsCreateStepStatus;
  detail?: string;
};

const STEP_LABELS: Record<LeanCustomsCreateStepId, string> = {
  create_order: "Create order in Lean Customs",
  sync_costs: "Send costs to Lean Customs (Kosten)",
  link_booking: "Link order to this booking",
  packing_slip: "Generate packing slip",
  upload_documents: "Upload invoice & packing slip",
  upload_attachments: "Upload extra bijlagen & save to booking",
  complete: "Finish",
};

const STEP_ORDER: LeanCustomsCreateStepId[] = [
  "create_order",
  "sync_costs",
  "link_booking",
  "packing_slip",
  "upload_documents",
  "upload_attachments",
  "complete",
];

export function buildInitialCreateSteps(): LeanCustomsCreateStep[] {
  return STEP_ORDER.map((id) => ({
    id,
    label: STEP_LABELS[id],
    status: "pending",
  }));
}

export function patchCreateStep(
  steps: LeanCustomsCreateStep[],
  id: LeanCustomsCreateStepId,
  patch: Partial<Pick<LeanCustomsCreateStep, "status" | "detail">>
): LeanCustomsCreateStep[] {
  return steps.map((step) => (step.id === id ? { ...step, ...patch } : step));
}

export function documentUploadDetail(
  documents: Array<{ bucket: string; path: string }>
): string {
  if (documents.length === 0) return "No documents to upload";
  const names = documents.map((d) => d.path.split("/").pop() ?? d.path);
  if (names.length === 1) return names[0];
  return `${names.length} files: ${names.join(", ")}`;
}

export function attachmentUploadDetail(filenames: string[]): string {
  if (filenames.length === 0) return "No attachments to upload";
  if (filenames.length === 1) return filenames[0];
  return `${filenames.length} files: ${filenames.join(", ")}`;
}

/** @deprecated Use attachmentUploadDetail */
export function directFileUploadDetail(filenames: string[]): string {
  return attachmentUploadDetail(filenames);
}
